import { signedDelta } from '@/lib/whats-new/formatting';

/**
 * "+22%" against the previous 30 days; nothing when the number went down,
 * stayed flat or has no previous period to compare with (NEWS-24).
 */
export function DeltaBadge({
  current,
  previous,
}: {
  current: number;
  previous: number | null | undefined;
}) {
  const delta = signedDelta(current, previous);
  if (delta === null) return null;
  return (
    <span className="inline-flex h-[22px] items-center gap-1 whitespace-nowrap rounded-full bg-[rgba(111,160,255,0.18)] px-2 text-xs font-semibold tabular-nums text-[#CFE0FF]">
      {delta}
    </span>
  );
}
